/* eslint-disable import/prefer-default-export */
export const stringToColor = (str, sat = '60%', lum = '80%') => {
  const res = str.split('').reduce(
    (sum, _, i) => sum + Number(str.charCodeAt(i)),
    0,
  ) % 360

  return `hsl(${res}, ${sat}, ${lum})`
}
